import axios from 'axios';
import { store } from './redux/store/store';
import actions from './redux/auth/action';

// 1. ADD `withCredentials: true` TO BOTH INSTANCES
let axiosApiInstance = axios.create({
  withCredentials: true 
});
export const axiosBasicAuth = axios.create({
  withCredentials: true
});

axiosApiInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axiosApiInstance.interceptors.request.use(function (config) {
  // 2. REMOVED ALL LOCAL STORAGE JWT LOGIC HERE. 
  // The browser will securely attach the HttpOnly cookie automatically.

  // Keep your Basic Auth for public/unauthenticated endpoints
  // let username = process.env.REACT_APP_USERNAME;
  // let password = process.env.REACT_APP_PASSWORD;
  // let authorizationBasic = username + ':' + password;
  // let basicAuth = 'Basic ' + btoa(authorizationBasic);
  // config.headers.common['Authorization'] = ` ${basicAuth}`;
  
  return config;
}, function (error) {
  if (error.response && error.response.status === 401) {
    store.dispatch(actions.authLogout());
  }
  if (error.response && error.response.status === 500) {
    if (error.response.data && error.response.data.message === "Token expired please login again.") {
      store.dispatch(actions.authLogout());
    }
  }
  return Promise.reject(error);
});

axiosApiInstance.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    store.dispatch(actions.authLogout());
  }
  if (error.response && error.response.status === 500) {
    if (error.response.data && error.response.data.message === "Token expired please login again.") {
      store.dispatch(actions.authLogout());
    }
  }
  return Promise.reject(error);
});

axiosBasicAuth.interceptors.request.use(function (config) {
  // let username = process.env.REACT_APP_USERNAME;
  // let password = process.env.REACT_APP_PASSWORD;
  // let authorizationBasic = username + ':' + password;
  // let basicAuth = 'Basic ' + btoa(authorizationBasic);
  // config.headers.common['Authorization'] = ` ${basicAuth}`;
  return config;
}, function (error) {
  return Promise.reject(error);
});

axiosBasicAuth.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    store.dispatch(actions.authLogout());
  }
  if (error.response && error.response.status === 500) {
    if (error.response.data && error.response.data.message === "Token expired please login again.") {
      store.dispatch(actions.authLogout());
    }
  }
  return Promise.reject(error);
});

export default axiosApiInstance;